var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33265 3.375C4.33265 2.96079 4.66844 2.625 5.08265 2.625L14.9251 2.625C15.3393 2.625 15.6751 2.96079 15.6751 3.375C15.6751 3.78921 15.3393 4.125 14.9251 4.125L5.08265 4.125C4.66844 4.125 4.33265 3.78921 4.33265 3.375ZM4.33276 14.625C4.33276 14.2108 4.66855 13.875 5.08276 13.875L14.9252 13.875C15.3394 13.875 15.6752 14.2108 15.6752 14.625C15.6752 15.0392 15.3394 15.375 14.9252 15.375L5.08276 15.375C4.66855 15.375 4.33276 15.0392 4.33276 14.625ZM1.40234 8.25C0.98813 8.25 0.652344 8.58579 0.652344 9C0.652344 9.41421 0.98813 9.75 1.40234 9.75L18.6002 9.75C19.0144 9.75 19.3502 9.41422 19.3502 9C19.3502 8.58579 19.0144 8.25 18.6002 8.25L1.40234 8.25Z",
    fill: "#8C99B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.303f3f855eabd1d66229412745ca9a8f.svg";
export { ForwardRef as ReactComponent };